import React from 'react';
import {checkSectionValid} from '../../Page/TransactionSummaryPage/Shared/HelperFunctions';
import {setLabels} from './helper/GeneralDetailsHelper'
import {transactionType} from '../../Page/TransactionSummaryPage/Shared/Constants'

const GeneralDetailsSubscriber = ({generalDetails, data, dealType, reasonCode}) => {
  const showComponent = checkSectionValid(generalDetails);
  const title = data.generalDetailsTopic.value === '' ? 'התוכנית שלך' : data.generalDetailsTopic.value;
  const subscriberNumbers = generalDetails.subscriberNumberList;
  let labels = {};
  if (showComponent) {
    labels = setLabels(dealType, reasonCode);
  }


  return showComponent ? (
    <div className='general-details'>
      <label className='general-details__topic'>{title}</label>
      <div className='content-collapse-container'>
        <div className='general-details__subscriber-content '>
          <div className='general-details__row1'>
            <div className='general-details__holder1'>
              <label>{labels.saleDate}</label>
              <span className='general-details__block-fram'>{generalDetails.saleDate}</span>
            </div>
          </div>
          <div className='general-details__row1'>
            <div className='general-details__holder1'>
              <label>{labels.orderNumber}</label>
              <span className='general-details__block-fram'>{generalDetails.orderNumber}</span>
            </div>
          </div>
          <div className='general-details__row1'>
            <div className='general-details__holder1'>
              <label>מועד סגירת החשבונית</label>
              <span className='general-details__block-fram'>{'ב- ' + generalDetails.billCycle + ' לכל חודש'}</span>
            </div>
          </div>
          {dealType !== transactionType.CancelDeal &&
            <div className='general-details__row'>
              <div className='general-details__holder-list'>
                <label>{subscriberNumbers.length == 1 ? 'מספר מנוי' : 'הקווים שנרכשו הם'} </label>

                {subscriberNumbers
                .filter(number => number !== "0000000000")
                .map((number, index) => (
                  <div key={index}>
                    <span className='general-details__phone__text'>{setStructNumber(number)}</span>
                  </div>
                ))}
              </div>
            </div>

          }
        </div>
        {data.generalDetailsMessage.value !== '' && <p className='general-details__message'>{data.generalDetailsMessage.value}</p>}
      </div>
    </div>
  ) : (
    null
  );
};
function setStructNumber(number) {
  var start = number.slice(0, 3);
  var end = number.slice(3, 10);
  return start + '-' + end;
}

export default GeneralDetailsSubscriber;
